import api from '@/api'

const state = {
  permissionList: [],
  roleList: [],
  roleDetail: {}
}
const actions = {
  getPermissionList({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.role.permissionList(params).then(
        response => {
          commit('setPermissionList', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getRoleList({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.role.roleList(params).then(
        response => {
          commit('setRoleList', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getRoleDetail({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      api.role.roleDetail(id).then(
        response => {
          commit('setRoleDetail', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  createRole({ _ }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.role.createRole(payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}
const mutations = {
  setPermissionList(state, value) {
    state.permissionList = value
  },
  setRoleList(state, value) {
    state.roleList = value
  },
  setRoleDetail(state, value) {
    state.roleDetail = value
  }
}
const getters = {
  permissionList: state => state.permissionList,
  roleList: state => state.roleList,
  roleDetail: state => state.roleDetail
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
